export default __webpack_public_path__ + "static/yazi-31373ad5948d0e755d687b29f38cf76f.png";